export default __webpack_public_path__ + "static/media/amazon_1.9a312edd.svg";